import { useState, useEffect } from 'react';
import axios from 'axios';

export const useSeekGlobalData = ({ key, endpoint }: { key: string; endpoint: string }) => {
  const [processedData, setProcessedData] = useState([]);

  useEffect(() => {
    const getCurrencies = async () => {
      const dataStr = localStorage.getItem(key);

      if (dataStr) {
        const dataFromLocalStorage = JSON.parse(dataStr);
        setProcessedData(dataFromLocalStorage);
        return;
      }

      try {
        const { data } = await axios.get(endpoint);
        const dataFromApi = data.data[key];
        setProcessedData(dataFromApi);
        localStorage.setItem(key, JSON.stringify(dataFromApi));
      } catch (error) {
        console.log(error);
      }
    };
    getCurrencies();
  }, [endpoint, key]);

  return { processedData, setProcessedData };
};
